export default __webpack_public_path__ + "static/media/liberum-2.d0c4bf48.png";